import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=036e0d6f&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=036e0d6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e0d6f",
  null
  
)

export default component.exports